import type { ListItemSummaryKpi } from "../utils/listItemSummaryHelpers"
import { formatCompactId, formatNumberId } from "../utils/listItemSummaryHelpers"

type KpiStripProps = {
  kpi: ListItemSummaryKpi
}

export function KpiStrip({ kpi }: KpiStripProps) {
  const items: { label: string; value: string }[] = [
    { label: "Total SKU", value: String(kpi.totalSku) },
    { label: "Total SOH", value: formatNumberId(kpi.totalSoh) },
    {
      label: "Inventory Value",
      value: formatCompactId(kpi.inventoryValueTotal)
    },
    { label: "Low Stock", value: String(kpi.lowStock) },
    { label: "Out of Stock", value: String(kpi.outOfStock) },
    {
      label: "Dead Stock Value",
      value: formatCompactId(kpi.deadStockValue)
    },
    {
      label: "Avg Margin",
      value:
        kpi.avgMarginPct !== null ? `${kpi.avgMarginPct.toFixed(0)}%` : "-"
    }
  ]

  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-4 xl:grid-cols-7">
      {items.map((item) => (
        <div
          key={item.label}
          className="card card-compact flex min-h-[5.5rem] flex-col items-center justify-center border border-[#dadada] bg-base-100 px-2 py-3 text-center shadow-sm sm:min-h-[6rem] sm:px-3">
          <p className="text-[10px] font-bold uppercase leading-tight text-base-content/55 sm:text-[11px]">
            {item.label}
          </p>
          <p className="mt-1 break-all text-xl font-bold leading-tight text-base-content sm:text-2xl xl:text-3xl">
            {item.value}
          </p>
        </div>
      ))}
    </div>
  )
}
